export default "__VITE_ASSET__By_2jqDf__"